import { applySpec, juxt, map, pathOr, pipe, toUpper, zipObj } from 'ramda'
import date from 'date-and-time'
import { splitClassesInWeeks } from '../../../../../Helpers/Timings'

const EnrollmentRequestSchema = applySpec({
  id: pathOr('', ['enrollmentId']),
  name: pathOr('', ['name']),
  cover: pathOr('', ['picture']),
  chatId: pathOr('', ['chatId']),
  userId: pathOr('', ['userId']),
  chatMessageId: pathOr('', ['chatMessageId']),
  auditionVideo: pathOr('', ['auditionVideo']),
  message: pathOr('', ['message']),
})

const ParticipantRequestSchema = applySpec({
  id: pathOr('', ['registrationId']),
  isPaid: pathOr(false, ['isPaid']),
  name: pathOr('', ['name']),
  cover: pathOr('', ['picture']),
  chatId: pathOr('', ['chatId']),
  userId: pathOr('', ['userId']),
})

export const BatchesSchema = applySpec({
  id: pathOr('', ['id']),
  name: pathOr('', ['name']),
  completedClasses: pathOr(0, ['classes', 'completed']),
  classCount: pathOr(0, ['classes', 'total']),
  registrationCount: pathOr(0, ['registrationCount']),
  requestCount: pathOr(0, ['requestCount']),
  nextClass: pipe(
    pathOr(0, ['nextClass', 'startTime']),
    juxt([
      pipe((dt) => date.format(new Date(dt), 'D MMM'), toUpper),
      pipe((dt) => date.format(new Date(dt), 'ddd'), toUpper),
      pipe((dt) => date.format(new Date(dt), 'h:mm A'), toUpper),
    ]),
    zipObj(['date', 'day', 'time']),
  ),
})

export const BatchTimingsSchema = applySpec({
  id: pathOr('', ['id']),
  classes: pipe(pathOr({}, ['classes']), splitClassesInWeeks),
  groupChatId: pathOr('', ['groupChatId']),
  registrations: pipe(
    pathOr([], ['participants']),
    map(ParticipantRequestSchema),
  ),
  requests: pipe(
    pathOr([], ['enrollmentRequests']),
    map(EnrollmentRequestSchema),
  ),
})
